(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('resumoOcorrencias', ResumoOcorrencias);

  function ResumoOcorrencias() {
    return {
      restrict: 'E',
      controller: 'ResumoOcorrenciasIndicadoresCtrl',
      templateUrl: 'views/painel_propriedade/_resumo_ocorrencias_indicadores.html'
    };
  }

}());
